/** @jsx jsx */
import { alpha } from "@theme-ui/color"
import { graphql, useStaticQuery } from "gatsby"
import SliderContainer from "./Slider/SliderContainer"
import { jsx } from "theme-ui"
import Layout from "../layout"
import SectionHeading from "../SectionHeading"

const CouponData = [
  {
    title: '20% OFF',
    subtitle: 'Your Dinner Check',
    condition: 'With purchase of $45 or more, Before tax.',
    terms: 'Coupon not valid for lunch or daily specials. Not valid with any other offers or Holidays. Valid dinner only.',
    expirationDate: '8.18.2020'
  },
  {
    title: 'FREE',
    subtitle: '3 Spring Rolls',
    condition: 'With purchase of $45 or more, Before tax.',
    terms: 'Coupon not valid for lunch or daily specials. Not valid with any other offers or Holidays. Valid dinner only.',
    expirationDate: '8.18.2020'
  },
  {
    title: 'FREE',
    subtitle: 'Egg Roll or Free Soda',
    condition: 'With purchase of $45 or more, Before tax.',
    terms: 'Coupon not valid for lunch or daily specials. Not valid with any other offers or Holidays. Valid dinner only.',
    expirationDate: '8.18.2020'
  },
  {
    title: '20% OFF',
    subtitle: 'Your Dinner Check',
    condition: 'With purchase of $45 or more, Before tax.',
    terms: 'Coupon not valid for lunch or daily specials. Not valid with any other offers or Holidays. Valid dinner only.',
    expirationDate: '8.18.2020'
  },
  {
    title: 'FREE',
    subtitle: '3 Spring Rolls',
    condition: 'With purchase of $45 or more, Before tax.',
    terms: 'Coupon not valid for lunch or daily specials. Not valid with any other offers or Holidays. Valid dinner only.',
    expirationDate: '8.18.2020'
  },
  {
    title: 'FREE',
    subtitle: 'Egg Roll or Free Soda',
    condition: 'With purchase of $45 or more, Before tax.',
    terms: 'Coupon not valid for lunch or daily specials. Not valid with any other offers or Holidays. Valid dinner only.',
    expirationDate: '8.18.2020'
  }
]

const Coupon = (props) => {
    const data = useStaticQuery(graphql`
        query {
            file(sourceInstanceName: {eq: "backgrounds"}, name: {eq: "coupon-bgr"}) {
                childImageSharp {
                 fluid(quality:100) {
                    ...GatsbyImageSharpFluid_withWebp
                 }
                }
            }
        }      
    `)

    return (
  <div sx={{
    boxSizing: 'border-box',
    px: 4,
  }}>
    <div sx={{filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.075))',}}>
        <div sx={{
        pt: 5,
        pb: 6,
        my: 5,
        bg: 'white',
        borderRadius: 2,
        
        boxShadow: 'small',
        maskImage: `url(${data.file.childImageSharp.fluid.src})`,
        maskRepeat: 'repeat-x',
        maskPosition: 'bottom center', 

        '> *': {
            px: 6
        }
        }}>
            <h3 sx={{
                fontSize: 4,
                color: 'secondaryColor',
                fontWeight: 'bold',

            }}>{props.title}</h3>
            <span sx={{
                fontSize: 2,
                fontWeight: 'bold'
            }}>{props.subtitle}</span>
            <p sx={{
                fontSize: 2,
                py: 4
            }}>{props.condition}</p>
            <p sx={{
                fontSize: 1,
                opacity: 0.8
            }}>{props.terms}</p>
            <div sx={{
                pt: 4,
                pb: 2,
                mt: 4,
                textAlign: 'center',
                fontWeight: 'bold',
                borderTop: '2px dashed black',
                borderTopColor: alpha("neutral600", 0.2)
            }}>Expires {props.expirationDate}</div>
        </div>
    </div>
  </div>
)}

export default function Coupons(props) {
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1010,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 880,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  };
  return (
    <Layout>
      <div sx={{
          py: [5, 5, 5],
          my: [5, 12, 12],
          position: 'relative'
        }} id={props.id}>
        <div sx={{textAlign: 'center'}}><SectionHeading caption="Our Latest Offers">Coupons</SectionHeading></div>
          <SliderContainer settings={settings}>
            {CouponData.map((item, index) => (
                <Coupon title={item.title} subtitle={item.subtitle} condition={item.condition} terms={item.terms} expirationDate={item.expirationDate} key={index}></Coupon>
            ))}
          </SliderContainer>
      </div>
    </Layout>
  );
  }